// Safe Meta Pixel wrapper. Uses the official `meta-pixel` package via dynamic import
// so any loading issue cannot break the React render.

const PIXEL_ID = '1673165833732305'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
    __mpPixel?: any
  }
}

let initPromise: Promise<void> | null = null

export function initPixel(): Promise<void> {
  if (typeof window === 'undefined') return Promise.resolve()
  if (initPromise) return initPromise

  initPromise = (async () => {
    try {
      const mod: any = await import('meta-pixel')
      const factory = mod.default || mod
      const pixel = typeof factory === 'function' ? factory(PIXEL_ID) : factory
      window.__mpPixel = pixel
      if (pixel && typeof pixel.track === 'function') {
        pixel.track('PageView')
      } else if (typeof window.fbq === 'function') {
        window.fbq('init', PIXEL_ID)
        window.fbq('track', 'PageView')
      }
    } catch (err) {
      // Silently fail — tracking should never break the UI
      console.warn('[pixel] init failed', err)
    }
  })()

  return initPromise
}

export function trackInitiateCheckout(value: number = 9.99) {
  if (typeof window === 'undefined') return
  try {
    const pixel = window.__mpPixel
    const payload = {
      content_name: 'MARSET: REY DEL SUR',
      content_type: 'product',
      currency: 'USD',
      value,
    }
    if (pixel && typeof pixel.track === 'function') {
      pixel.track('InitiateCheckout', payload)
    } else if (typeof window.fbq === 'function') {
      window.fbq('track', 'InitiateCheckout', payload)
    }
  } catch (err) {
    console.warn('[pixel] track failed', err)
  }
}
